export default "__VITE_ASSET__YfKKv9a6__"